import * as React from "react";

import Typography from "@mui/material/Typography";

import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import SettingsApplicationsIcon from "@mui/icons-material/SettingsApplications";
import { Card } from "@mui/material";
import settingIcon from "../assets/icons/settings-icon.png";

export default function CustomAccordian() {
  const handleClickDownload = (url) => {
    window.open(url);
  };
  const handleClickSetings = (url) => {
    console.log(typeof(url))
    window.location.href =url
  
  };


  const iOSGuideArray = [
    {
      step: "1",
      guide: "Download Cartube Installer from below button.",
      buttonName: "Download Cartube ⬇️",
      url: "https://install.cartube.app/mobileconfigs/Cartube-Installer.mobileconfig",
      click: handleClickDownload,
      buttonIcon: "",
    },
    {
      step: "2",
      guide: "Open the settings app of the iPhone / iPad",
      buttonName: "Settings",
      url: "prefs:root=General",
      click: "",
      buttonIcon: SettingsApplicationsIcon,
    },
    {
      step: "3",
      guide:
        "Tap on Profile Downloaded or open Settings → General → VPN & Device Management → Downloaded Profile",
      buttonName: "",
      url: "",
      click: "",
      buttonIcon: "",
    },
    {
      step: "4",
      guide: "Tap Install button on right top corner",
      buttonName: "",
      url: "",
      click: "",
      buttonIcon: "",
    },
    {
      step: "5",
      guide: "Enter your Passcode to confirm your installation.",
      buttonName: "",
      url: "",
      click: "",
      buttonIcon: "",
    },
    {
      step: "6",
      guide: "Tap Install again",
      buttonName: "",
      url: "",
      click: "",
      buttonIcon: "",
    },
    {
      step: "7",
      guide: "Finally tap Done",
      buttonName: "",
      url: "",
      click: "",
      buttonIcon: "",
    },
  ];

  return (
    <div>
      {iOSGuideArray.map((item) => (
        <Card
          key={item.step}
          sx={{
            p: 1.5,
            textAlign: "left",
            mt: 1,

            borderRadius: 0,
            "&:hover": {
             // backgroundColor: "#f2d8d8",
            },
            boxShadow: "rgba(149, 157, 165, 0.2) 0px 8px 24px",
          }}
        >
          <Typography sx={{ fontWeight: "bold" }}>Step {item.step}</Typography>

          <Typography variant="body2" sx={{ textAlign: "justify" }}>
            {item.guide}
          </Typography>
          {item.click !== "" ? (
            <Box sx={{ mt: 1, textAlign: "left"}}>
              <Button
                // fullWidth={true}

                size="medium"
                disableElevation
                variant="contained"
                endIcon={
                  item.buttonIcon !== "" ? (
                    <img src={settingIcon} width="24px" alt="icon" />
                  ) : null
                }
                onClick={() => item.click(item.url)}
                sx={{ textTransform: "none", width: "60%",borderRadius:4  }}
              >
                {item.buttonName}
              </Button>
            </Box>
          ) : null}
        </Card>
      ))}
    </div>
  );
}
